// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"805357f6","647":"e8d017d9"}[chunkId] + ".chunk.js";
};